import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaHeart, FaCheck, FaPlus, FaTrash } from 'react-icons/fa';
import './LoveListPage.css';

const LoveListPage = () => {
  const [loveList, setLoveList] = useState([
    {
      id: 1,
      task: '一起看日出',
      completed: true,
      category: '浪漫',
      emoji: '🌅'
    },
    {
      id: 2,
      task: '一起做饭',
      completed: true,
      category: '生活',
      emoji: '👨‍🍳'
    },
    {
      id: 3,
      task: '去海边度假',
      completed: false,
      category: '旅行',
      emoji: '🏖️'
    },
    {
      id: 4,
      task: '学会一支舞蹈',
      completed: false,
      category: '技能',
      emoji: '💃'
    },
    {
      id: 5,
      task: '拍一套情侣照',
      completed: true,
      category: '纪念',
      emoji: '📸'
    },
    {
      id: 6,
      task: '一起爬山看云海',
      completed: false,
      category: '冒险',
      emoji: '⛰️'
    },
    {
      id: 7,
      task: '看一场演唱会',
      completed: false,
      category: '娱乐',
      emoji: '🎵'
    },
    {
      id: 8,
      task: '种一棵属于我们的树',
      completed: false,
      category: '纪念',
      emoji: '🌳'
    },
    {
      id: 9,
      task: '一起学习新语言',
      completed: false,
      category: '技能',
      emoji: '📚'
    },
    {
      id: 10,
      task: '制作爱情相册',
      completed: true,
      category: '纪念',
      emoji: '📖'
    }
  ]);

  const [newTask, setNewTask] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('浪漫');
  const [showAddForm, setShowAddForm] = useState(false);

  const categories = ['浪漫', '生活', '旅行', '技能', '纪念', '冒险', '娱乐'];
  const categoryEmojis = {
    '浪漫': '💕',
    '生活': '🏠',
    '旅行': '✈️',
    '技能': '🎯',
    '纪念': '📝',
    '冒险': '🗺️',
    '娱乐': '🎭'
  };

  const toggleTask = (id) => {
    setLoveList(loveList.map(item => 
      item.id === id ? { ...item, completed: !item.completed } : item
    ));
  };

  const deleteTask = (id) => {
    setLoveList(loveList.filter(item => item.id !== id));
  };

  const addTask = () => {
    if (newTask.trim()) {
      const newItem = {
        id: Date.now(),
        task: newTask,
        completed: false,
        category: selectedCategory,
        emoji: categoryEmojis[selectedCategory]
      };
      setLoveList([...loveList, newItem]);
      setNewTask('');
      setShowAddForm(false);
    }
  };

  const completedCount = loveList.filter(item => item.completed).length;
  const totalCount = loveList.length;
  const progress = totalCount > 0 ? (completedCount / totalCount) * 100 : 0;

  return (
    <motion.div
      className="love-list-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.8 }}
    >
      <div className="love-list-container">
        <motion.div
          className="love-list-header"
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          <Link to="/" className="back-btn">
            <FaArrowLeft /> 返回首页
          </Link>
          <h1 className="love-list-title">
            <FaHeart className="title-icon" />
            爱情清单
            <FaHeart className="title-icon" />
          </h1>
          <p className="love-list-subtitle">我们想要一起完成的美好事情</p>
          
          <div className="progress-section">
            <div className="progress-text">
              已完成 {completedCount} / {totalCount} 项 ({Math.round(progress)}%)
            </div>
            <div className="progress-bar">
              <motion.div 
                className="progress-fill"
                initial={{ width: 0 }}
                animate={{ width: `${progress}%` }}
                transition={{ delay: 0.5, duration: 1 }}
              />
            </div>
          </div>
        </motion.div>

        <motion.div
          className="category-filter"
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.8 }}
        >
          {categories.map((category) => (
            <button
              key={category}
              className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category)}
            >
              {categoryEmojis[category]} {category}
            </button>
          ))}
        </motion.div>

        <motion.div
          className="love-list-grid"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.8 }}
        >
          {loveList.map((item, index) => (
            <motion.div
              key={item.id}
              className={`love-list-item ${item.completed ? 'completed' : ''}`}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8 + index * 0.1, duration: 0.5 }}
              whileHover={{ scale: 1.02, y: -5 }}
            >
              <div className="item-emoji">{item.emoji}</div>
              <div className="item-content">
                <h3 className="item-task">{item.task}</h3>
                <span className="item-category">{categoryEmojis[item.category]} {item.category}</span>
              </div>
              <div className="item-actions">
                <button 
                  className={`check-btn ${item.completed ? 'completed' : ''}`}
                  onClick={() => toggleTask(item.id)}
                >
                  <FaCheck />
                </button>
                <button 
                  className="delete-btn"
                  onClick={() => deleteTask(item.id)}
                >
                  <FaTrash />
                </button>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          className="add-task-section"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 1, duration: 0.5 }}
        >
          {!showAddForm ? (
            <button 
              className="add-task-btn"
              onClick={() => setShowAddForm(true)}
            >
              <FaPlus />
              添加新的愿望
            </button>
          ) : (
            <div className="add-form">
              <input
                type="text"
                value={newTask}
                onChange={(e) => setNewTask(e.target.value)}
                placeholder="输入我们想要一起做的事情..."
                className="task-input"
                onKeyPress={(e) => e.key === 'Enter' && addTask()}
              />
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                className="category-select"
              >
                {categories.map((category) => (
                  <option key={category} value={category}>
                    {categoryEmojis[category]} {category}
                  </option>
                ))}
              </select>
              <div className="form-actions">
                <button className="confirm-btn" onClick={addTask}>
                  确认添加
                </button>
                <button 
                  className="cancel-btn" 
                  onClick={() => {
                    setShowAddForm(false);
                    setNewTask('');
                  }}
                >
                  取消
                </button>
              </div>
            </div>
          )}
        </motion.div>
      </div>
    </motion.div>
  );
};

export default LoveListPage;


